import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors } from '@/utils/constants';

const lightTheme = { root: { '& $icon': { color: SecondaryColors.dark } } };
const darkTheme = { root: { '& $icon': { color: SecondaryColors.main } } };

export const useSearchBarStyles = makeStyles(
  (muiTheme) => ({
    root: {
      background: 'white',
      border: 'none',
      height: '50px',
      borderRadius: '4px 0 0 4px',
    },
  }),
  { name: 'GenMarketplaceSearchBarInput' },
);

export const useStyles = makeStyles(
  (muiTheme) => ({
    container: {
      padding: 0,
    },
    wrapper: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
      width: '100%',
      height: '50px',
      display: 'flex',
      flexDirection: 'row',
      alignContent: 'stretch',

      [muiTheme.breakpoints.up('md')]: {
        '&.desktop-large': {
          height: '70px',
          '& .MuiInputBase-root': {
            height: '70px !important',
          },
          '& $button': {
            height: '70px',
            width: '216px',
          },
          '& $icon': {
            marginLeft: '24px',
          },
        },
      },
    },
    button: {
      '&.MuiButton-root': {
        height: '100%',
        boxShadow: 'none',
        borderRadius: '0 4px 4px 0',

        '&:hover': {
          boxShadow: 'none',
        },
      },
    },
    icon: {
      marginLeft: muiTheme.spacing(2),
    },
    mobile: {
      display: 'none',
      [muiTheme.breakpoints.up('md')]: {
        display: 'inline',
        textTransform: 'capitalize',
        marginRight: muiTheme.spacing(1),
      },
    },
  }),
  { name: 'GenMarketplaceSearchBar' },
);
